import { ProductSpec } from "../interface"

export const powerArQ2: ProductSpec = {
  id: 'l0970',
  name: 'PowerArQ2',
  url:  process.env.GATSBY_TARGET_CHANNEL === 'rakuten' ? "https://item.rakuten.co.jp/kashima-tokeiten/ac50/" : "https://powerarq.com/products/ac50",
  capacity: 500,
  batteryType: 'マンガン系',
  colors: [
    'coyote-tan',
    'olive-drab',
    'jet-black',
    'red',
    'charcoal',
    'snow-white'
  ],
  defaultColor: 'coyote-tan',
  price: 69300,
  // salePrice: 47840,
  description: 'ワイヤレス充電、LEDライトなど新たな機能を備えたPowerArQの後継機。機能や容量、サイズのバランスが良く、迷った場合はこちらをおすすめ',
  chargingTime: 7,
  chargingTimeWithSolar: { input: 80, value: 8 },
  chargingTimeWithCar: { input: 100, value: 6.5 },
  maximumOutput: 300,
  smartphone: 42,
  electricBlanket: 9,
  fan: 14,
  ledLight: 142,
  riceCooker: 1.7,
  projector: 7,
  fridge: 14,
  electricCarpet: 2,
  acPort: 2,
  usbA: 4,
  usbC: 1,
  qi: 1,
  builtInLed: 520,
  weight: 6.2
}